// src/modules/login/RecoveryPassword.js
import React, { useState } from 'react';
import Form from '../../components/shared/Form';
import Input from '../../components/shared/Input';
import Button from '../../components/shared/Button';

const RecoveryPassword = () => {
  const [email, setEmail] = useState('');
  const [question, setQuestion] = useState('');  // Optionally fetch a recovery question
  const [answer, setAnswer] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Submit recovery request
  };

  return (
    <Form onSubmit={handleSubmit}>
      <h2>Account Recovery</h2>
      <Input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <Input
        type="text"
        placeholder="Security Question"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
      />
      <Input
        type="text"
        placeholder="Answer"
        value={answer}
        onChange={(e) => setAnswer(e.target.value)}
      />
      <Button type="submit">Recover Account</Button>
    </Form>
  );
};

export default RecoveryPassword;
